export default __webpack_public_path__ + "83041a77c014b3428bb4c38943d5523b.svg";